import React from "react";
import TopBannerData from "../../model/top/bannerData";
import CreatorsBannerData from "../../model/creators/creationBannerData";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from "swiper";
import {Autoplay, Pagination, Navigation} from 'swiper/modules';
import 'swiper/css';
import { LanguageUtils } from "../../language/LanguageUtils";

SwiperCore.use([Pagination, Autoplay, Navigation]);
export function TopBannerSlider(datas: TopBannerData[])
{
    if (datas.length == 0)
    {
        return null;
    }

    return (
        <>
        <Swiper
            loop={true} // ループ
            speed={1000}
            pagination={{
                'el': '.swiper-pagination',
                'clickable': true,
            }}
            navigation={{
                'nextEl': '.swiper-button-next',
                'prevEl': '.swiper-button-prev',
            }}
            autoplay={{
                'delay': 3000,
                'disableOnInteraction': false
            }}
            // 画面幅に応じた表示枚数を設定
            breakpoints={{
                // 769px以上の画面幅では3枚表示
                769: {
                    'slidesPerView': 3
                },
                // 768px以下の画面幅では1枚表示
                0: {
                    'slidesPerView': 1.5,
                    'centeredSlides': true
                }
            }}
            onSwiper={() => {
                // 初期化後にフェードイン
                let swiper = document.querySelector<HTMLElement>('.swiper');
                swiper?.setAttribute('style', 'opacity:1');
            }}
        >
            {
                // スライド生成
                datas.map((content, index) => {
                    return <SwiperSlide key={index}><a href={content.url} target="_blank"><img src={`./assets/img/top/${LanguageUtils.getLanguage()}/${content.imageFile}`} alt={datas[0].altText} /></a></SwiperSlide>;
                })
            }
        </Swiper>
        </>
    );
}

export function TopPopupSlider(datas: string[],
                                setActiveIndex: React.Dispatch<React.SetStateAction<number>>,
                                swiperRef: React.RefObject<SwiperCore | null>,
                                allowPrev: boolean,
                                setAllowPrev: React.Dispatch<React.SetStateAction<boolean>>,
                                allowNext: boolean,
                                setAllowNext: React.Dispatch<React.SetStateAction<boolean>>
)
{
    const handleSlideChange = (swiper: SwiperCore) => {
        const isStart = swiper.realIndex === 0;
        const isEnd = swiper.realIndex === datas.length - 1;

        setAllowPrev(!isStart);
        setAllowNext(!isEnd);
        setActiveIndex(swiper.activeIndex)
    };

    if (datas.length == 0)
    {
        return null;
    }

    return (
        <>
        <Swiper
            loop={false} // ループ
            speed={1000}
            allowSlidePrev={allowPrev}
            allowSlideNext={allowNext}
            pagination={{
                'el': `.swiper-pagination-popup`,
                'clickable': false,
            }}
            navigation={{
                'nextEl': `.swiper-button-next-popup`,
                'prevEl': `.swiper-button-prev-popup`,
            }}
            onSlideChange={(swiper: SwiperCore) => handleSlideChange(swiper)}
            onSwiper={(swiper: SwiperCore) => {
                swiperRef.current = swiper;
                // 初期状態の制御
                const isStart = swiper.realIndex === 0;
                const isEnd = swiper.realIndex === datas.length - 1;
                setAllowPrev(!isStart);
                setAllowNext(!isEnd);
            }}
        >
        {
            // スライド生成
            datas.map((content, index) => {
                return <SwiperSlide key={index}><img src={"./assets/img/top/"+content} alt={"イラスト"} className="popup-image"/></SwiperSlide>;
            })
        }
        </Swiper>
        </>
    );
}

export function CreatorsBannerSlider(datas: CreatorsBannerData[])
{
    if (datas.length == 0)
    {
        return null;
    }

    return (
    <>
    <Swiper
        loop={true}
        speed={1000}
        pagination={{
            'el': '.swiper-pagination',
            'clickable': true,
        }}
        navigation={{
            'nextEl': '.swiper-button-next',
            'prevEl': '.swiper-button-prev',
        }}
        autoplay={{
            'delay': 6000,
            'disableOnInteraction': false,
        }}
    >
        {
            // スライド生成
            datas.map((content, index) => {
                return (
                <SwiperSlide key={index}>
                    <div className="bg_paper">
                        <h3 className="banner_ttl">《 {content.titleText} 》</h3>
                        <div className="img"><img src={`../assets/img/creators/${content.imageFile}`} alt={content.titleText} width="580" height="326"/></div>
                        <p className="txt" dangerouslySetInnerHTML={{__html: content.contentText}}></p>
                        <div className="btn_hexagon">
                            <a href={content.url} target="_blank">{content.buttonText}</a>
                        </div>
                    </div>
                </SwiperSlide>
                )
            })
        }
    </Swiper>
    </>
    );
}